module.exports = __webpack_public_path__ + "img/cursor-fill.8310c6bb.svg";